<template>
  <div id="service" class="service-wrap ptb-100">
    <div class="service-bg bg-f"></div>
    <div class="container">
      <div class="row">
        <div class="col-xl-6 offset-xl-3 col-lg-8 offset-lg-2">
          <div class="section-title style2 text-center mb-40">
            <span>What's Happening</span>
            <h2>We're Providing Best Services To Our Customers</h2>
          </div>
        </div>
      </div>

      <Carousel
        :autoplay="5000"
        :wrap-around="true"
        :breakpoints="breakpoints"
        pause-autoplay-on-hover
        class="service-slider-one style2"
      >
        <Slide v-for="service in services" :key="service.id">
          <div class="service-card style8">
            <div class="service-icon">
              <i :class="service.icon"></i>
            </div>
            <div class="service-info">
              <h3>
                <router-link to="/service-details">
                  {{ service.title }}
                </router-link>
              </h3>
              <p>{{ service.shotDesc }}</p>
            </div>
          </div>
        </Slide>

        <template #addons>
          <Navigation />
        </template>
      </Carousel>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { Carousel, Slide, Navigation } from "vue3-carousel";

export default defineComponent({
  name: "BestServices",
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  data: () => ({
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
    services: [
      {
        id: 1,
        icon: "flaticon-brain",
        title: "Brain Affirm",
        shotDesc:
          "It is a long established fact that reader will be distracted by content layout.",
      },
      {
        id: 2,
        icon: "flaticon-cancer",
        title: "Palate Cancer",
        shotDesc:
          "It is a long established fact that reader will be distracted by content layout.",
      },
      {
        id: 3,
        icon: "flaticon-orthopedics",
        title: "Orthopedic Care",
        shotDesc:
          "It is a long established fact that reader will be distracted by content layout.",
      },
      {
        id: 4,
        icon: "flaticon-health-report",
        title: "Full Health Checkup",
        shotDesc:
          "It is a long established fact that reader will be distracted by content layout.",
      },
      {
        id: 5,
        icon: "flaticon-health-report",
        title: "Free Checkup",
        shotDesc:
          "It is a long established fact that reader will be distracted by content layout.",
      },
    ],
    breakpoints: {
      0: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      768: {
        itemsToShow: 2,
        snapAlign: "start",
      },
      1200: {
        itemsToShow: 3,
        snapAlign: "center",
      },
      1400: {
        itemsToShow: 4,
        snapAlign: "start",
      },
    },
  }),
});
</script>